import { Box, Tooltip } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { useDispatch } from 'react-redux';
import { ReactComponent as DocumentIcon } from '../../assets/icons/document-icon.svg';
import { ReactComponent as FolderIcon } from '../../assets/icons/folder-icon.svg';
import { ReactComponent as Model3dIcon } from '../../assets/icons/model-3d-icon.svg';
import { ReactComponent as Scene3DIcon } from '../../assets/icons/scene-3d-icon.svg';
import { AttachmentTreeItem } from '../../models/models';
import { openDialog } from '../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../store/dialog/dialog.types';
import { FlexBoxFullW } from '../layout/layout.styles';
import {
    TreeViewAttachmentName,
    TreeViewFolderName,
} from './attachments-tree-view.styles';

const AttachmentsTreeView = ({ items }: { items: AttachmentTreeItem[] }) => {
    const dispatch = useDispatch();

    const renderTreeView = (items: AttachmentTreeItem[], parentId: string) => {
        return items.map((item) => {
            const key = `${parentId}-${item.id}-${item.type}`;

            const getLabel = () => {
                const handleItemClick = () => {
                    if (item.path) {
                        if (item.type === '3d') {
                            dispatch(
                                openDialog(
                                    DIALOG_TYPES.SHARE_SCENE_3D,
                                    { sceneId: item.id },
                                    'xs'
                                )
                            );
                            return;
                        }
                        const path = `${process.env.REACT_APP_BASE_URL}${item.path}`;
                        window.open(path, '_blank', 'noopener,noreferrer');
                    }
                };
                switch (item.type) {
                    case 'folder':
                        return (
                            <FlexBoxFullW
                                alignItems={'center'}
                                gap={1}
                                height={20}
                            >
                                <Box
                                    minWidth={30}
                                    display={'flex'}
                                    alignItems={'center'}
                                    height={1}
                                >
                                    <FolderIcon height={18} />
                                </Box>
                                <Tooltip title={item.name}>
                                    <TreeViewFolderName>
                                        {item.name}
                                    </TreeViewFolderName>
                                </Tooltip>
                            </FlexBoxFullW>
                        );
                    case 'document':
                        return (
                            <a
                                href={item.path}
                                download
                                style={{ color: 'white' }}
                            >
                                <FlexBoxFullW
                                    alignItems={'center'}
                                    gap={1}
                                    height={20}
                                >
                                    <Box
                                        minWidth={30}
                                        display={'flex'}
                                        alignItems={'center'}
                                        height={1}
                                    >
                                        <DocumentIcon height={18} />
                                    </Box>
                                    <Tooltip title={item.name}>
                                        <TreeViewAttachmentName>
                                            {item.name}
                                        </TreeViewAttachmentName>
                                    </Tooltip>
                                </FlexBoxFullW>
                            </a>
                        );
                    case 'model':
                        return (
                            <a
                                href={item.path}
                                download
                                style={{ color: 'white' }}
                            >
                                <FlexBoxFullW
                                    alignItems={'center'}
                                    gap={1}
                                    height={20}
                                >
                                    <Box
                                        minWidth={30}
                                        display={'flex'}
                                        alignItems={'center'}
                                        height={1}
                                    >
                                        <Model3dIcon height={18} />
                                    </Box>
                                    <Tooltip title={item.name}>
                                        <TreeViewAttachmentName>
                                            {item.name}
                                        </TreeViewAttachmentName>
                                    </Tooltip>
                                </FlexBoxFullW>
                            </a>
                        );
                    case '3d':
                        return (
                            <FlexBoxFullW
                                alignItems={'center'}
                                gap={1}
                                height={20}
                                onClick={handleItemClick}
                            >
                                <Box
                                    minWidth={30}
                                    display={'flex'}
                                    alignItems={'center'}
                                    height={1}
                                >
                                    <Scene3DIcon height={18} />
                                </Box>
                                <Tooltip title={item.name}>
                                    <TreeViewAttachmentName color="white">
                                        {item.name}
                                    </TreeViewAttachmentName>
                                </Tooltip>
                            </FlexBoxFullW>
                        );
                    default:
                        return null;
                }
            };

            return (
                <TreeItem key={key} itemId={key} label={getLabel()}>
                    {item.children && renderTreeView(item.children, key)}
                </TreeItem>
            );
        });
    };

    return <SimpleTreeView>{renderTreeView(items, '0')}</SimpleTreeView>;
};

export default AttachmentsTreeView;
